import styled from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden';
import { colors, transition } from 'theme';

export const TabSwitcherTabInput = styled.input`
  ${visuallyHiddenCss}

  &:checked + label {
    color: ${colors.brandBlue};
  }
`;

export const TabSwitcherTabLabel = styled.label<{ isSelected: boolean }>`
  user-select: none;
  display: inline-block;
  padding: 16px;
  background: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: ${transition};
  position: relative;

  color: ${colors.lightContentGrey};

  ${(props) =>
    props.isSelected && `border-bottom: 2px solid ${colors.brandBlue};`}

  &:hover {
    ${(props) =>
      !props.isSelected &&
      `border-bottom: 2px solid ${colors.lightContentGrey};`}
  }
`;
